module.exports = __webpack_public_path__ + "static/media/img_4.690a541a.jpg";